import React from "react";
import { LoaderCircleIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface ILoaderProps {
	children: React.ReactNode;
	loading: boolean;
	fullscreen?: boolean;
	wrapperClass?: string;
	overlayClass?: string;
	loaderSize?: number;
}

export default function OverlayLoader(props: ILoaderProps) {
	return (
		<div className={cn(props.fullscreen ? '' : 'relative', props.wrapperClass)}>
			{props.loading && (
				<div className={`absolute flex items-center justify-center inset-0 bg-black/50 z-10 ${props.overlayClass || ""}`}>
					<LoaderCircleIcon className="text-white animate-spin" size={(props.loaderSize ?? 12) * 4} />
				</div>
			)}
			{props.children}
		</div>
	);
}
